import React, { useState } from "react";
import { Formik, Form as FORM } from "formik";
import { Link, useHistory } from "react-router-dom";
import * as Yup from "yup";
// import Button from "../Utility/Button";
import { useSelector } from "react-redux";
// import "./Professional.css";
import Logo from '../Images/Logo.jpeg'
// import { notifyerror, notifysuccess } from "../Utility/Notification";
import { Helmet } from "react-helmet";
import {domain} from "../App";
import { useAuth } from "../authContext"

// Material ui
import {styled} from '@material-ui/core/styles'
import Hidden from "@material-ui/core/Hidden";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button'
import CircularProgress from "@material-ui/core/CircularProgress";

// Styled componenst with material styled
const Wrapper=styled('div')({
  width:'100%',
  minHeight:'100vh',
  maxHeight:'100vh',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'row'
})

const LeftLogo=styled('div')({
  width:'50%',
  height:'100vh',
  backgroundColor:'#f0f0f0',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'column'
})

const FormContainer=styled('div')({
  width:'100%',
  height:'100vh',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'column'
})

const FormSetter=styled('div')({
  paddingTop:'40px',
  width:'90%',
  maxWidth:'400px',
  display:'flex',
  alignItems:'center',
  justifyContent:'center',
  flexDirection:'column'
  // backgroundColor:'#46516d'
})

const StyledLogo=styled('div')({
  width:'250px',
  height:'200px'
})

const StyledText=styled(Typography)({
  textAlign:"center",
  paddingTop:"30px"
})

const StyledField=styled(TextField)({
  marginTop:'10px'
})

const StyledButton=styled(Button)({
  width:'400px',
  marginTop:'10px',
  backgroundColor:'#46516d',
  color:'#fff',
  border:'1px solid #46516d',
  '&:hover':{
    backgroundColor:'#46516d',
  }
})
//////////////////////////////

const initialvalue = {
  name: "",
  password: "",
  email: '',
};

const validation = Yup.object().shape({
  name: Yup.string()
      .min(2, "please enter correct name")
      .max(20, "please enter correct name")
      .required("Name is required"),
  email: Yup.string().email()
      .min(5)
      .required("Required"),
  password: Yup.string()
      .min(7, "Password should be min 7 characters")
      .required("Password is required"),
});
export default function (props) {
  const [loading,setLoading]=useState(false)
  const history = useHistory();
  const {from} = {from:{pathname:"/"}};
  const { signup } = useAuth()

  const handleSubmit = async(values) => {
    console.log(values,"----signup values")
    // e.preventDefault()
    try {
      setLoading(true)
      await signup(values.email,values.password,values.name )
      history.push("/")
    } catch {
      
    }

    setLoading(false)
  }


  return (
      <>
        <Helmet>
          <title>Register</title>
          <meta
              name="description"
              content="Get Your All home Problems solved by one fill up"
          />
        </Helmet>
        <Wrapper>
          {/* Hidden on small screen size leftLogo */}
          <Hidden smDown>
            <LeftLogo>
              <StyledLogo>
                 <img height='100%' width='100%' src={Logo} alt={"AtUrServices-logo"} style={{borderRadius:'13px'}} />
              </StyledLogo>
              <StyledText variant='h4'>
                Service at your Doorstep
              </StyledText>
            </LeftLogo>
          </Hidden>
          <FormContainer>
            <StyledText variant='h4'>
              Register to AturServices
            </StyledText>
            <FormSetter>
              <Formik
                  initialValues={initialvalue}
                  validationSchema={validation}
                  onSubmit={handleSubmit}
              >
                {props=>{
                  const{
                    values,
                    touched,
                    errors,
                    handleChange,
                    handleBlur,
                  }=props;
                  {/* console.log(values,"--values inside") */}
                  return(
                      <FORM autoComplete='true' style={{width:'100%'}} >
                        <StyledField
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.name}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            label='Name'
                            name='name'
                            error={errors.name&&touched.name?true:false}
                            helperText={errors.name && touched.name ?errors.name:null}
                        />
                        <StyledField
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            label='Email'
                            name='email'
                            type={"email"}
                            error={errors.email&&touched.email?true:false}
                            helperText={errors.email && touched.email ?errors.email:null}
                        />
                        <StyledField
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            variant='outlined'
                            fullWidth
                            margin='dense'
                            label='Password'
                            name='password'
                            error={errors.password&&touched.password?true:false}
                            helperText={errors.password && touched.password ?errors.password:null}
                        />
                        <div style={{width:'100%',display:'flex',alignItems: 'center',justifyContent: 'center'}}>
                          <StyledButton
                              disableFocusRipple={true}
                              disableElevation={true}
                              type='submit'
                              variant='outlined'
                              disabled={loading?true:false}
                          >
                            {loading ?
                                <CircularProgress style={{height:'20px',width:'20px',color:'#fff'}} />
                                : 'Sign Up'}
                          </StyledButton>
                        </div>
                      </FORM>
                  )
                }}
              </Formik>
              <Typography style={{marginTop:'10px'}} varient='caption'>
                Already have a account?{" "}
                <Link
                    style={{textDecoration:'none',color:'#46516d'}}
                    to='/login'>Login</Link>
              </Typography>
            </FormSetter>
          </FormContainer>
        </Wrapper>
      </>
  );
}
